
import Vue from "vue";
import AffiliateCard from "@/components/Portal/AffiliateCard.vue";
import affiliateService from "@/services/portal/affiliateService";

export default Vue.extend({
  components: { AffiliateCard },
  name: "AffiliateList",
  data: function () {
    return {
      affiliates: [] as any [],
      currentItems: [] as any [],
      countries: [] as string [],
      states: [] as string [],
      selectedCountries: [] as string [],
      selectedStates: [] as string [],
      showLoader: false,
      search: "",
      dialog: false,
      selectedAffiliate: null as any | null,
      affiliatesListingHeaders: [
        { text: "Country", align: "left", value: "country" },
        { text: "State", align: "left", value: "region" },
        { text: "Club Name", align: "left", value: "name",  groupable: false },
        { text: "Club Website", align: "left", value: "clubSite", groupable: false },
        { text: "Affiliate Representative", align: "left", value: "contact.name", groupable: false },
        { text: "Representative Email", align: "left", value: "contact.email", groupable: false },
        { text: "Representative Phone", align: "left", value: "contact.phoneNumber", groupable: false },
        { text: "More", value: "actions", sortable: false, groupable: false },
      ],
    };
  },
  created: function () {
    this.showLoader = true;
    affiliateService.getAffiliates().then((res: any) => {
      this.$data.affiliates = res.affiliates;
      this.$data.states = [
        ...this.$data.states,
        ...res.states,
      ];
      this.$data.countries = [
        ...this.$data.countries,
        ...res.countries,
      ];
      this.showLoader = false;
    });
  },
  computed: {
    filteredAffiliates() {
      if(this.$data.selectedCountries.length === 0 && this.$data.selectedStates.length === 0)
        this.$data.affiliates;      
      const filteredByCountries = this.$data.selectedCountries.length === 0 ? 
        this.$data.affiliates
        : this.$data.affiliates.filter((affiliate: { country: string }) =>
            this.$data.selectedCountries.includes(affiliate.country)
      );
      const filteredByStates = this.$data.selectedStates.length === 0 ?           
        filteredByCountries
        : filteredByCountries.filter((affiliate: { state: string }) =>
            this.$data.selectedStates.includes(affiliate.state)
      );
      return filteredByStates;
    },
  },
  methods: { 
    csvExport: function () {
        var filename = `AffiliatesListing_${new Date().toLocaleDateString()}.csv`;
        var content = this.currentItems;
        const keys = ['Country', 'Region', 'Name', 'Website', 'Affiliate Representative', 'Representative Email', 'Representative Phone', 'President', 'President Email', 'President Phone',];
        const commaSeparatedString = [keys.join(","), 
          content.map((row: any) => 
          [row.country, row.region, row.name, row.clubSite, row.contact.name, row.contact.email, row.contact.phoneNumber, row.president.name, row.president.email, row.president.phoneNumber].join(",")).join("\n")].join("\n")
        const csvBlob = new Blob([commaSeparatedString])
        var link = document.createElement("a");
        var url = URL.createObjectURL(csvBlob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },  
    currentItemsUpdate: function(value: any){
      this.currentItems = value;
    },
  },
  watch: {
      dialog(val) {
        if (!val) {
          this.selectedAffiliate = null;
          this.dialog = false;
        }
      },
  },
});
